import Head from 'next/head';

import { getServerSidePropsStatusWrapper } from '@kc-console/guard';

import type { NextPageWithLayout } from '@/application/types';

import { EventDetailTemplate } from '@/pages/event-detail/ui';
import { getServiceConstants } from '@/shared/config/routes';

const EventInfoPage: NextPageWithLayout = () => {
  const { EVENT_TITLE } = getServiceConstants();
  return (
    <>
      <Head>
        <title>{EVENT_TITLE}</title>
      </Head>
      <EventDetailTemplate />
    </>
  );
};

export default EventInfoPage;

export const getServerSideProps = getServerSidePropsStatusWrapper();
